"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationFailed = void 0;
var AuthenticationFailed;
(function (AuthenticationFailed) {
    AuthenticationFailed["notActivated"] = "notActivated";
    AuthenticationFailed["invalidEmailOrPassword"] = "invalidEmailOrPassword";
})(AuthenticationFailed || (exports.AuthenticationFailed = AuthenticationFailed = {}));
//# sourceMappingURL=AuthenticationFailed.js.map